import Base from './base.js';
import Gikam from "../core/gikam-core";
import Vue from 'vue';

// 样品储存位置
let defaultOptions = {
    data: [],
    url: void 0,
    rowNum: void 0,
    colNum: void 0,
    width: void 0,
    height: void 0,
    bgIcon: void 0,
    bgColor: void 0,
    onClick: void 0,
    onDblClick: void 0,
    onLoadSuccess: void 0, // 接口加载完成
    onRendered: void 0 // 组件渲染完成
};

export default class SampleLocation extends Base {
    constructor(options) {
        super(options);
        this.initialize(options, defaultOptions).init();
    }

    createViewModel () {
        const _this = this;

        this.sampleLoc = new Vue({
            el: Gikam.createDom('div', this.options.renderTo),
            render () {
                return <sample-location ref="sampleLocation" onMounted={this.mountedHandle} options={this.options}></sample-location>
            },
            components: {
                sampleLocation: () => import('@/gikam/js/components/template/sampleLocation/sampleLocation.vue')
            },
            data () {
                return {
                    options: _this.options
                };
            },
            methods: {
                mountedHandle () {
                    _this.bindInstance(_this.sampleLoc.$el);
                }
            }
        });

        this.options.url && this.urlPostData();
    }

    // [公用方法]——设置数据
    setData (data) {
        this.options.data = data;
    }

    // [公用方法]——添加到某个位置
    addSample (data) {
        this.sampleLoc.$refs.sampleLocation.addSampleFn(data);
    }

    // 调用接口-初始化完成触发
    urlPostData () {
        let _this = this;
        let sampleUrl = this.options.url;
        Gikam.getJson(sampleUrl).done((data) => {
            _this.setData(data.rows);
            if (_this.options.onLoadSuccess) {
                _this.options.onLoadSuccess(data.rows);
            }
        });
    }

    /**
     * 选中事件
     * @public
     * @param { String } nodeId 节点id
     * @memberof SampleLocation
     */
    sampleSelect(id, type) {
        let data = this.options.data.filter(item => item.id === id)[0];
        data && this.sampleLoc.$refs.sampleLocation.sampleActive(data, type);
        !data && this.sampleLoc.$refs.sampleLocation.sampleActive(data, false);
        if (this.options.onClick) {
            this.options.onClick(data, type);
        }
    }

    init () {
        this.createViewModel();
    }
}